// extracted by mini-css-extract-plugin
export default {"price":"P6-z","onSale":"Q6-z","msrpLabelPrice":"R6-z","msrpLabel":"S6-z","originalPrice":"T6-z","percentOff":"U6-z"};